<script setup>
const props = defineProps({
  text: String,
  size: String,
});
</script>

<template>
  <div class="">
    <div class="ok__container">
      <div class="ok__text">
        <p class="mb-0" v-html="text"></p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ok__container {
  background-color: #C7E8CA;
  padding: 10px 15px;
  border-radius: 0.5em;
  text-align: center;
  width: 100%;
  .ok__text {
    color: #3d3b3b;
    p {
      font-family: 'CircularStd-Book';
      font-size: 14px;
      margin-bottom: 0;
    }
    
  }
 
}
</style>
